var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",[_vm._v(_vm._s(null))],{"src":_vm.src})],2)}
var staticRenderFns = []

export { render, staticRenderFns }